export default {
  data: {} as any
}
